<ol class="stepper">
  @for (step of steps; track track(i, step); let i = $index) {
    <li
      class="stepper__step"
      [class.stepper__step--done]="isDone(i)"
      [class.stepper__step--active]="isActive(i)"
      [attr.aria-current]="isActive(i) ? 'step' : null"
    >
      <!-- Die Linie gehoert zum Schritt rechts davon, damit ihr Fuellstand
           genau mit dessen Zustand umschaltet. -->
      @if (i > 0) {
        <span class="stepper__line"
          ><span class="stepper__line-fill"></span
        ></span>
      }

      <span class="stepper__marker">
        @if (isDone(i)) {
          <app-svg-icon
            [src]="'icons/24/check.svg'"
            [svgStyle]="{ 'width.px': '14', 'height.px': '14' }"
          ></app-svg-icon>
        } @else {
          {{ i + 1 }}
        }
      </span>

      <span class="stepper__label">{{ step | translate }}</span>
    </li>
  }
</ol>
